import * as React from "react";

import { ActionIcon, Center, Group, Tooltip } from "@mantine/core";
import { IconGripVertical, IconTrash } from "@tabler/icons-react";
import { DraggableProvided } from "react-beautiful-dnd";

import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useCountEvent } from "../../hooks/useCountEvent";
import { ChecklistHeader } from "../../lib/model/checklistAppState";
import { librarySlice } from "../../lib/state/reducer";

import { ChecklistElementAdjustmentsMenu } from "./ChecklistElementAdjustmentsMenu";
import { InlineEditableTitle } from "./text/InlineEditableText";

export const ChecklistHeaderEditor = ({
  checklistHeaderState,
  dragHandleProps,
  onRemove,
  autoAdd,
}: {
  checklistHeaderState: ChecklistHeader;
  dragHandleProps: DraggableProvided["dragHandleProps"];
  onRemove: () => void;
  autoAdd?: () => void;
}): JSX.Element => {
  const reduxDispatch = useAppDispatch();

  const addMore = React.useCallback(() => {
    if (autoAdd) {
      autoAdd();
    }
  }, [autoAdd]);
  const countEvent = useCountEvent();
  return (
    <Center>
      <Group
        spacing={0}
        mt="xs"
        style={{ backgroundColor: checklistHeaderState.styles?.backgroundColor }}
      >
        <ActionIcon variant="transparent" size="sm" style={{ zIndex: 20 }} {...dragHandleProps}>
          <IconGripVertical size={16} />
        </ActionIcon>
        <Group position="apart">
          <InlineEditableTitle
            text={checklistHeaderState.text}
            onSave={(newValue) => {
              reduxDispatch(
                librarySlice.actions.updateChecklistElement({
                  elementId: checklistHeaderState.id,
                  elementField: "header",
                  newValue,
                })
              );
              countEvent("checklist-header-content-edited");
            }}
            onEmptyEnter={addMore}
            onEmptyTab={addMore}
            order={4}
            placeholder="Header"
            extraPadding={10}
            justify="center"
            styles={{
              borderBottom: "1px solid #000",
              ...checklistHeaderState.styles,
            }}
          />
        </Group>
        <Group spacing={0}>
          <ChecklistElementAdjustmentsMenu checklistElement={checklistHeaderState} />
          <Tooltip withArrow label="Delete" openDelay={500}>
            <ActionIcon size="sm" onClick={() => onRemove()}>
              <IconTrash size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Group>
    </Center>
  );
};
